import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderSquareOneFirstFloor = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Modern version (floor 1)", lang)}</h4>
              <p>
                1741,45{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>156 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_One/US1_1P modern.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("3 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
              <li>{t("Storage", lang)}</li>
            </ul>
            <a
              href={require("../assets/pdf/UNITY-Square-One-1st-floor-modern.pdf")}
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Traditional version (floor 1)", lang)}</h4>
              <p>
                1741,15{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>211 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_One/US1_1P traditional.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("2 office room / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("8 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("1 storage room", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
            </ul>
            <a
              href={require("../assets/pdf/UNITY-Square-One-1st-floor-traditional.pdf")}
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-One-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-One-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderSquareOneFirstFloor
